// pages/order/StepImported.tsx
import { ImportedByPicView } from "@/components/private/order/ImportedByPicView";
import { useUser } from "@/context/useUser";

export default function StepImported() {
    const { data: user } = useUser();
    // Pastikan mengirim pic_id dari data participant
    return <ImportedByPicView picId={user?.participant?.pic_id || ""} />;
}